<template>

  <template v-if="hasOptions(filters.category)">
    <div class="section__header  mb-4">
      <div class="section__title  section__title--lg">{{in18['page_filter_category_title']}}</div>
    </div><!-- /.section__header -->
    <div class="row  mb-5">
      <div v-for="subcategory in filters.category.options" class="col-lg-3  col-sm-6  col-6  mb-6">
        <a :href="subcategory.link" :title="subcategory.title" class="category">

          <a :href="subcategory.link" :title="subcategory.title" class="category__img_link">
            <picture>
              <source :srcset="subcategory.image.webp" type="image/webp">
              <img :src="subcategory.image.source" alt="" class="category__img">
            </picture>
          </a>

          <div class="category__title">{{ subcategory.title }}</div>
          <div class="category__count">{{ subcategory.count }} {{ in18['page_products'] }}</div>
        </a>
      </div>
    </div>
    <hr>
  </template>
</template>

<script>
export default {
  name:    "catalogSubcategories",
  props:   {
    filters: Object,
    in18:     Object,
  },
  methods: {
    /**
     * Check if a filter has options.
     * @param {Object} filter - The filter to check.
     * @returns {boolean} - True if the filter has options, otherwise false.
     */
    hasOptions(filter) {
      return filter && filter.options && filter.options.length > 0;
    },
  }
};
</script>

<style scoped>
/* Add CSS styling for your subcategory cards */
.subcategory-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.subcategory-card {
  width: calc(25% - 10px); /* 4 columns with some spacing */
  margin-bottom: 20px;
  border: 1px solid #ccc; /* Add border to each card */
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
}

.subcategory-image {
  max-width: 100%;
  height: auto;
}

.subcategory-title {
  margin-top: 10px;
}
</style>
